import {defineStore} from 'pinia';
import {ModuleBudgetItem} from '../moduleConst';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import budgetItemAPI from '@/apis/di/budgetItemAPI';
import ColumnCommon from '@/commons/wildcards/constants/ColumnCommon';

const budgetItemStore = new BaseDictionaryStore(budgetItemAPI);

export const useBudgetItemStore = defineStore(ModuleBudgetItem, {
  state: () => ({
    ...budgetItemStore.state,
    _config: {
      key: 'budget_item_id',
      code: 'budget_item_code',
      table: 'di_budget_item',
      quickFollow: 'active',
      moduleName: ['Mục/Tiểu mục chi', 'Mục/Tiểu mục thu'],
      defaultSort: ColumnCommon.budgetItemCode,
      quickFollow: 'active',
      isTree: true
    },
    moduleName: 'budgetItem',
  }),
  actions: {...budgetItemStore.action},
  getters: {...budgetItemStore.getters},
});
